import { AxiosResponse } from 'axios';
import { TagRequest } from 'types/tag/TagTypes';
import { APIClient } from 'services/helpers/api_helper';
import * as url from 'services/helpers/url_helper';
import {
  DeleteMultiTagsResponse,
  DeleteTagResponse,
  GetTagsResponse,
  PostCreateTagResponse,
  PutUpdateTagResponse,
} from 'types/APIResponsesTypes';
// import {
//   CreateTag,
//   UpdateTag,
//   AssignProductToTag,
// } from 'types/tag/tagTypes';
// import { AxiosResponse } from 'axios';

const api = new APIClient();

// export const getTags = async (
//   keyword = '',
//   page = 1,
//   limit = 50,
//   sort_order = 'asc',
// ) => {
//   try {

//     const response: Promise<GetTagsResponse> = await api.get(url.GET_TAGS, {
//       keyword,
//       page,
//       limit,
//       sort_order,
//     });

//     return response;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };
export const getTags = async (
  keyword = '',
  page = 1,
  limit = 50,
  active: number | null = null,
  sort_order = 'asc'
) => {
  try {
    const params: Record<string, any> = {
      keyword,
      page,
      limit,
      sort_order,
    };

    if (active !== null) {
      params.active = active;
    }

    const response: Promise<GetTagsResponse> = await api.get(url.GET_TAGS, {
      params,
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAddTag = async (FormData: TagRequest) => {
  try {
    const response: Promise<PostCreateTagResponse> = await api.create(
      url.POST_ADD_TAG,
      FormData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateTag = async (tagId: number, FormData: TagRequest) => {
  try {
    const response: Promise<PutUpdateTagResponse> = await api.put(
      `${url.PUT_UPDATE_TAG}${tagId}`,
      FormData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteTagById = async (tagId: string) => {
  try {
    const response: AxiosResponse<DeleteTagResponse> = await api.delete(
      `${url.DELETE_TAG}${tagId}`
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const deleteMultiTags = async (tagIds: number[]) => {
  try {
    const response: AxiosResponse<DeleteMultiTagsResponse> = await api.delete(
      url.DELETE_BULK_TAG,
      {
        data: {
          tag_ids: tagIds,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

// export const assignProductToTag = async (data: AssignProductToTag) => {
//   try {
//     const response: Promise<AssignProductToTagResponse> = await api.create(
//       url.ASSIGN_PRODUCT_TAG,
//       data
//     );
//     return response;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };

// export const removeProductTag = async (
//   productId: number,
//   tagId: number
// ) => {
//   try {
//     const response: AxiosResponse<RemoveProductTagResponse> = await api.delete(
//       `${url.REMOVE_PRODUCT_TAG}/${productId}/${tagId}`
//     );
//     return response;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };
